import React, { useState, useCallback, useEffect } from "react";

import { useConversations } from "../contexts/ConversationsProvider";
import { timeDifference } from "../utils/func";

import {
  Input,
  Form,
  Button,
  Badge,
  Label,
  FormGroup,
  ModalBody,
  ModalHeader,
  Modal,
  ModalFooter,
} from "reactstrap";

import { DOMAIN } from "../utils";
import avatar from "../../assets/img/default-avatar.png";

import { useContacts } from "../contexts/ContactsProvider";
import { SEND_READ_STATUS } from "../utils";
import { API_TIMEOUT } from "../utils";
import axios from "axios";
import swal from "sweetalert";
import { DELETE_MESSAGE } from "../utils";

export default function OpenConversation({ id }) {
  const [text, setText] = useState("");
  const setRef = useCallback((node) => {
    if (node) {
      node.scrollIntoView({ smooth: true });
    }
  }, []);
  const { sendMessage, selectedConversation } = useConversations();
  const [msgRender, setMsgRender] = useState(selectedConversation.messages);

  useEffect(() => {
    if (selectedConversation) {
      setMsgRender(selectedConversation.messages);
    }
  }, [selectedConversation]);

  const { contacts } = useContacts();
  const [modalOpen, setModalOpen] = useState(false);

  const [unreadmsg, setunreadmsg] = useState("");

  function countUnreadMessages(messages) {
    let unreadCount = 0;
    let unreadMessages = [];

    messages.forEach((message) => {
      if (!message.readStatus && message.msgId) {
        unreadCount++;
        unreadMessages.push({ messageid: message.msgId, userid: id });
      }
    });

    return {
      unreadCount: unreadCount,
      unreadMessages: unreadMessages,
    };
  }

  useEffect(() => {
    setunreadmsg(countUnreadMessages(selectedConversation.messages));
  }, [selectedConversation]);

  useEffect(() => {
    if (unreadmsg && unreadmsg.unreadCount > 0) {
      sendReadStatus();
    }
  }, [unreadmsg]);

  const sendReadStatus = () => {
    axios({
      method: "post",
      url: SEND_READ_STATUS,
      timeout: API_TIMEOUT,
      data: unreadmsg.unreadMessages,
    })
      .then((response) => {
        if (response.status !== 200) {
          // ERROR
          return "error";
        } else {
          //BERHASIL
        }
      })
      .catch((error) => {
        // ERROR

        alert(error);
      });
  };

  function handleSubmit(e) {
    e.preventDefault();

    sendMessage(
      selectedConversation.recipients.map((r) => r.id),
      text,
      selectedConversation.conversationId
    );
    setText("");
  }

  function findContactProfileById(id) {
    const contact = contacts.find((contact) => contact.id === id);
    return contact ? contact.profile : undefined;
  }

  const deleteMsg = (msgid) => {
    const data = msgRender;
    const msgFil = data.filter((item) => {
      return item.msgId != msgid;
    });
    setMsgRender(msgFil);
  };

  const deleteMessage = (msgid) => {
    deleteMsg(msgid);

    axios({
      method: "delete",
      url: DELETE_MESSAGE + msgid,
      timeout: API_TIMEOUT,
    })
      .then((response) => {
        if (response.status !== 200) {
          // ERROR
          return "error";
        } else {
          //BERHASIL
        }
      })
      .catch((error) => {
        // ERROR

        alert(error);
      });
  };

  return (
    <div
      className="d-flex flex-column flex-grow-1"
      style={{
        backgroundColor: "#f5f7fa",
      }}
    >
      {/* Header */}
      <div
        style={{
          backgroundColor: "#ffffff",
          padding: "20px 25px",
          borderBottom: "1px solid #e9ecef",
          boxShadow: "0 2px 4px rgba(0,0,0,0.05)",
          flexShrink: 0,
        }}
      >
        {selectedConversation.recipients.length > 1 ? (
          <div
            style={{
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              gap: "10px",
            }}
            onClick={() => setModalOpen(true)}
          >
            <span
              style={{
                fontSize: "18px",
                fontWeight: 600,
                color: "#2c3e50",
              }}
            >
              {selectedConversation.nama}
            </span>
            <Badge
              style={{
                backgroundColor: "#667eea",
                padding: "5px 12px",
                borderRadius: "15px",
                fontSize: "12px",
                fontWeight: 600,
              }}
            >
              {selectedConversation.recipients.length} anggota
            </Badge>
          </div>
        ) : (
          <div
            style={{
              fontSize: "18px",
              fontWeight: 600,
              color: "#2c3e50",
              display: "flex",
              alignItems: "center",
              gap: "12px",
            }}
          >
            <span>💬</span>
            <span>
              {selectedConversation.recipients.map((r) => r.name).join(", ")}
            </span>
          </div>
        )}
      </div>

      {/* Messages Area */}
      <div
        className="flex-grow-1"
        style={{
          padding: "20px",
          overflowY: "auto",
          overflowX: "hidden",
          minHeight: 0,
          backgroundImage:
            "radial-gradient(circle at 20% 50%, rgba(102, 126, 234, 0.05) 0%, transparent 50%), radial-gradient(circle at 80% 80%, rgba(118, 75, 162, 0.05) 0%, transparent 50%)",
        }}
      >
        <div className="d-flex flex-column align-items-start justify-content-end">
          {msgRender.map((message, index) => {
            const lastMessage = msgRender.length - 1 === index;
            return (
              <div
                ref={lastMessage ? setRef : null}
                key={index}
                className={`d-flex flex-column`}
                style={{
                  marginBottom: "15px",
                  width: "100%",
                  alignItems: message.fromMe ? "flex-end" : "flex-start",
                }}
              >
                <div
                  style={{
                    maxWidth: "70%",
                    position: "relative",
                    padding: "12px 16px",
                    borderRadius: message.fromMe
                      ? "18px 18px 4px 18px"
                      : "18px 18px 18px 4px",
                    backgroundColor: message.fromMe
                      ? "linear-gradient(135deg, #667eea 0%, #764ba2 100%)"
                      : "#ffffff",
                    background: message.fromMe
                      ? "linear-gradient(135deg, #667eea 0%, #764ba2 100%)"
                      : "#ffffff",
                    color: message.fromMe ? "#ffffff" : "#2c3e50",
                    boxShadow: message.fromMe
                      ? "0 2px 8px rgba(102, 126, 234, 0.3)"
                      : "0 2px 8px rgba(0, 0, 0, 0.1)",
                    wordWrap: "break-word",
                    fontSize: "14px",
                    lineHeight: "1.5",
                  }}
                >
                  {message.text}
                  {message.fromMe && (
                    <div
                      style={{
                        width: 20,
                        height: 20,
                        borderRadius: 10,
                        backgroundColor: "rgba(255, 255, 255, 0.3)",
                        position: "absolute",
                        right: -8,
                        top: -8,
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        cursor: "pointer",
                        transition: "all 0.2s ease",
                        border: "2px solid white",
                      }}
                      onClick={() => deleteMessage(message.msgId)}
                      onMouseEnter={(e) => {
                        e.target.style.backgroundColor = "rgba(255, 0, 0, 0.7)";
                        e.target.style.transform = "scale(1.1)";
                      }}
                      onMouseLeave={(e) => {
                        e.target.style.backgroundColor =
                          "rgba(255, 255, 255, 0.3)";
                        e.target.style.transform = "scale(1)";
                      }}
                    >
                      <span
                        style={{
                          fontSize: 12,
                          color: "white",
                          fontWeight: "bold",
                        }}
                      >
                        ×
                      </span>
                    </div>
                  )}
                </div>
                <div
                  style={{
                    marginTop: "6px",
                    fontSize: "11px",
                    color: "#6c757d",
                    display: "flex",
                    alignItems: "center",
                    gap: "6px",
                    flexDirection: message.fromMe ? "row-reverse" : "row",
                  }}
                >
                  <img
                    style={{
                      width: 18,
                      height: 18,
                      borderRadius: 9,
                      objectFit: "cover",
                      border: "1px solid #e9ecef",
                    }}
                    src={
                      findContactProfileById(message.sender) != "-"
                        ? DOMAIN + findContactProfileById(message.sender)
                        : avatar
                    }
                    alt="avatar"
                  />
                  <span style={{ fontWeight: 500 }}>
                    {message.fromMe ? "Anda" : message.senderName}
                  </span>
                  <span>•</span>
                  <span style={{ color: "#28a745", fontSize: "10px" }}>
                    {timeDifference(message.createdAt)}
                  </span>
                </div>
              </div>
            );
          })}
        </div>
      </div>

      {/* Input Area */}
      <div
        style={{
          backgroundColor: "#ffffff",
          padding: "20px 25px",
          borderTop: "1px solid #e9ecef",
          boxShadow: "0 -2px 10px rgba(0,0,0,0.05)",
          flexShrink: 0,
        }}
      >
        <Form onSubmit={handleSubmit}>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              gap: "12px",
              alignItems: "flex-end",
            }}
          >
            <Input
              type="textarea"
              required
              value={text}
              onChange={(e) => setText(e.target.value)}
              placeholder="Ketik pesan..."
              style={{
                minHeight: "50px",
                maxHeight: "120px",
                resize: "none",
                color: "#2c3e50",
                padding: "12px 16px",
                borderRadius: "25px",
                border: "2px solid #e9ecef",
                fontSize: "14px",
                transition: "all 0.3s ease",
                flex: 1,
              }}
              onFocus={(e) => {
                e.target.style.borderColor = "#667eea";
                e.target.style.boxShadow = "0 0 0 3px rgba(102, 126, 234, 0.1)";
              }}
              onBlur={(e) => {
                e.target.style.borderColor = "#e9ecef";
                e.target.style.boxShadow = "none";
              }}
            />
            <Button
              type="submit"
              style={{
                minHeight: "50px",
                minWidth: "50px",
                borderRadius: "50%",
                backgroundColor: "#667eea",
                border: "none",
                padding: "0",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                boxShadow: "0 4px 15px rgba(102, 126, 234, 0.4)",
                transition: "all 0.3s ease",
                fontSize: "20px",
              }}
              onMouseEnter={(e) => {
                e.target.style.backgroundColor = "#5568d3";
                e.target.style.transform = "translateY(-2px)";
                e.target.style.boxShadow =
                  "0 6px 20px rgba(102, 126, 234, 0.5)";
              }}
              onMouseLeave={(e) => {
                e.target.style.backgroundColor = "#667eea";
                e.target.style.transform = "translateY(0)";
                e.target.style.boxShadow =
                  "0 4px 15px rgba(102, 126, 234, 0.4)";
              }}
            >
              ➤
            </Button>
          </div>
        </Form>
      </div>
      <Modal
        size="sm"
        isOpen={modalOpen}
        toggle={() => setModalOpen(false)}
        contentClassName="p-0"
        modalClassName="modal-slide-in event-sidebar"
      >
        <ModalHeader toggle={() => setModalOpen(false)}>
          <Label
            style={{
              fontWeight: 600,
              fontSize: "18px",
              color: "#2c3e50",
            }}
          >
            👥 Anggota Group
          </Label>
        </ModalHeader>
        <ModalBody style={{ padding: "25px" }}>
          <div
            style={{
              maxHeight: "400px",
              overflowY: "auto",
            }}
          >
            {selectedConversation.recipients.map((contact) => (
              <div
                key={contact.id}
                style={{
                  display: "flex",
                  alignItems: "center",
                  padding: "12px",
                  marginBottom: "8px",
                  borderRadius: "12px",
                  backgroundColor: "#f8f9fa",
                  border: "1px solid #e9ecef",
                  transition: "all 0.2s ease",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.backgroundColor = "#f0f4ff";
                  e.currentTarget.style.borderColor = "#667eea";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.backgroundColor = "#f8f9fa";
                  e.currentTarget.style.borderColor = "#e9ecef";
                }}
              >
                <img
                  style={{
                    width: 40,
                    height: 40,
                    borderRadius: 20,
                    marginRight: 12,
                    objectFit: "cover",
                    border: "2px solid #e9ecef",
                    boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                  }}
                  src={
                    findContactProfileById(contact.id) != "-"
                      ? DOMAIN + findContactProfileById(contact.id)
                      : avatar
                  }
                  alt={contact.name}
                />
                <Label
                  style={{
                    margin: 0,
                    fontWeight: 500,
                    fontSize: "15px",
                    color: "#2c3e50",
                    cursor: "default",
                  }}
                >
                  {contact.name}
                </Label>
              </div>
            ))}
          </div>
        </ModalBody>
        <ModalFooter
          style={{
            justifyContent: "center",
            padding: "20px 25px",
            borderTop: "1px solid #e9ecef",
          }}
        >
          <Button
            style={{
              borderRadius: "25px",
              backgroundColor: "#667eea",
              border: "none",
              padding: "10px 30px",
              fontWeight: 600,
              boxShadow: "0 4px 15px rgba(102, 126, 234, 0.4)",
              transition: "all 0.3s ease",
            }}
            onClick={() => setModalOpen(false)}
            onMouseEnter={(e) => {
              e.target.style.backgroundColor = "#5568d3";
              e.target.style.transform = "translateY(-2px)";
              e.target.style.boxShadow = "0 6px 20px rgba(102, 126, 234, 0.5)";
            }}
            onMouseLeave={(e) => {
              e.target.style.backgroundColor = "#667eea";
              e.target.style.transform = "translateY(0)";
              e.target.style.boxShadow = "0 4px 15px rgba(102, 126, 234, 0.4)";
            }}
          >
            Tutup
          </Button>
        </ModalFooter>
      </Modal>
    </div>
  );
}
